<div>
    <div fxLayout="row" style="height: 105px;" fxLayoutAlign="center center" fxLayoutGap="10%">
        <ngx-skeleton-loader fxFlex="50" count="1" appearance="line"></ngx-skeleton-loader>
        <ngx-skeleton-loader fxFlex="50" count="1" appearance="line"></ngx-skeleton-loader>
    </div>
</div>
<div class="item">
    <ngx-skeleton-loader count="8" appearance="line"></ngx-skeleton-loader>
</div>